import ApiCaller from 'actions/ApiCaller';
import baseAjaxConfig from 'actions/BaseAjaxConfig';
import get from 'lodash/get';
export var IPaymentTokenAction;
(function (IPaymentTokenAction) {
    IPaymentTokenAction["GET_PAYMENT_TOKEN_REQUEST"] = "GET_PAYMENT_TOKEN_REQUEST";
    IPaymentTokenAction["GET_PAYMENT_TOKEN_SUCCESS"] = "GET_PAYMENT_TOKEN_SUCCESS";
    IPaymentTokenAction["GET_PAYMENT_TOKEN_ERROR"] = "GET_PAYMENT_TOKEN_ERROR";
    IPaymentTokenAction["UPDATE_PAYMENT_TOKEN"] = "UPDATE_PAYMENT_TOKEN";
})(IPaymentTokenAction || (IPaymentTokenAction = {}));
export function getPaymentTokenAction() {
    return { type: IPaymentTokenAction.GET_PAYMENT_TOKEN_REQUEST };
}
export function getPaymentTokenSuccessAction(data) {
    return { type: IPaymentTokenAction.GET_PAYMENT_TOKEN_SUCCESS, data };
}
export function getPaymentTokenErrorAction(error) {
    return { type: IPaymentTokenAction.GET_PAYMENT_TOKEN_ERROR, error };
}
export function updatePaymentTokenAction(token) {
    return { type: IPaymentTokenAction.UPDATE_PAYMENT_TOKEN, token };
}
export function fetchPaymentTokenAction() {
    const tokenConfig = Object.assign({}, baseAjaxConfig, {
        pathname: '/api/3/checkout/paymentToken',
        action: IPaymentTokenAction.GET_PAYMENT_TOKEN_REQUEST
    });
    return dispatch => {
        dispatch(getPaymentTokenAction());
        return ApiCaller.get(tokenConfig).then(tokenResp => {
            const getPaymentToken = get(tokenResp, ['RESPONSE', 'getPaymentToken']);
            const paymentToken = get(getPaymentToken, ['token']);
            const callbackUrl = get(getPaymentToken, ['callBackUrl']);
            const message = get(getPaymentToken, ['alertMessage', 'message']);
            return dispatch(getPaymentTokenSuccessAction({ paymentToken, callbackUrl, message }));
        }, err => {
            dispatch(getPaymentTokenErrorAction(err));
            return Promise.reject(err);
        });
    };
}
